import { Button, Grid, Box } from "@mui/material";
import { useAuth } from "~contexts/Auth";
import { InfoCard } from "~components/atoms";
import { EyeDashIcon } from "~components/Icons";
import { LogoutIcon } from "~components/Icons/NavigationMenuIcons";
import { getStyles } from "./styles";

const SidebarChat = () => {
  const { Logout } = useAuth();
  const { styles } = getStyles();

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      sx={styles.wrapper}
    >
      <Box>
        <Button
          sx={styles.button}
          disableRipple
          disableFocusRipple
          onClick={Logout}
          startIcon={<LogoutIcon />}
        >
          sair da conta
        </Button>
        <InfoCard icon={<EyeDashIcon />} title="mensagens não lidas" amount="0.000" />
      </Box>
    </Grid>
  );
};

export default SidebarChat;
